import PropTypes from "prop-types";
import "./SectionHeading.css";

export default function SectionHeading({ heading, number }) {
  return (
    <div className="h2-container">
      <div className="h2number">{number}</div>
      <h2>{heading}</h2>
    </div>
  );
}

SectionHeading.propTypes = {
  heading: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
};
